var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal2",
    {
      staticClass: "voice-assistant-modal",
      attrs: { title: "", visible: true },
      on: { cancel: _vm.closeModal, ok: _vm.closeModal },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _c("div", { staticClass: "d-flex gap-5 title" }, [
                _c("img", { attrs: { src: "/static/img/copilot.png" } }),
                _vm._v(" "),
                _c("h2", [
                  _vm._v(_vm._s(_vm.$t("ticket.thisPageVoiceAssistant"))),
                ]),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "voice-assistant-content" }, [
        _c("h2", [
          _vm._v(
            _vm._s(_vm.$t("ticket.hello")) + " " + _vm._s(_vm.user.name) + " 👋"
          ),
        ]),
        _vm._v(" "),
        _c("p", { domProps: { innerHTML: _vm._s(_vm.translatedMessage) } }),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v('CTRL + "')]),
            _vm._v(" " + _vm._s(_vm.$t("ticket.commandHoldingDownTheKey"))),
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.$t("ticket.topRightContent")) +
                " "
            ),
            _c("img", {
              attrs: {
                src: "/static/img/copilot.png",
                width: "40",
                height: "40",
              },
            }),
            _vm._v(
              " " + _vm._s(_vm.$t("ticket.clickOnTheIcon")) + "\n            "
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "manual-main-content" }, [
          _c("div", { staticClass: "voice-commands" }, [
            _c("h3", [_vm._v(_vm._s(_vm.$t("ticket.sampleVoiceCommands")))]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v('"' + _vm._s(_vm.$t("ticket.showMyTickets")) + '"'),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"' + _vm._s(_vm.$t("ticket.showMeZeynepsOpenTicket")) + '"'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"' + _vm._s(_vm.$t("ticket.deleteTicketsScreen")) + '"'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"' + _vm._s(_vm.$t("ticket.assigntLastTicketAli")) + '"'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"' + _vm._s(_vm.$t("ticket.changeStatusAllTicket")) + '"'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"' + _vm._s(_vm.$t("ticket.setStatusTicketsScreen")) + '"'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  '"' + _vm._s(_vm.$t("ticket.assigntUserTicketScreen")) + '"'
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v('"' + _vm._s(_vm.$t("ticket.assigntFirstTicket")) + '"'),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v('"' + _vm._s(_vm.$t("ticket.showIgTickets")) + '"'),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("img", {
            attrs: {
              src: "https://static.supsis.live/common/image/ticket-copilot.gif",
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "assistant-animation" }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }